module.exports = __webpack_public_path__ + "img/67.57784dd0.jpg";